import Body from '@/components/body/Body'
import { Container } from '@/components/ui/container'
import { HEADER_HEIGHT } from '@/constants'
import useColorModeValue from '@/hooks/useColorModeValue'

import { MobileAppWidget } from './components/mobileApp/MobileAppWidget'

const MobileApp = () => {
    return (
        <Container
            maxW="100%"
            h={[`calc(100% - ${HEADER_HEIGHT.mobile})`, `calc(100% - ${HEADER_HEIGHT.mobile})`, `calc(100% - ${HEADER_HEIGHT.desktop})`]}
            display="flex"
            flexDirection="column"
            flexGrow="1"
            padding="24px"
            backgroundColor={useColorModeValue('var(--chakra-colors-surface-light)', 'black')}
        >
            <Body>
                <MobileAppWidget />
            </Body>
        </Container>
    )
}

export default MobileApp
